import { DatePicker, Button, Form, Space, Input, Select, message, Popconfirm, Row, Col } from "antd";
import { serverFetch } from "../../server";
import { useState, useEffect } from "react";
import { strDate2Server } from "../../extensions/utils";
import { dictsGetPaymentVids } from "../../extensions/dicts"
import { isMobile } from "../../extensions/design";
import { CloseOutlined } from "@ant-design/icons";

const ClientPaymentChange = ({ paymentItem, onClose, isAbon = true, isModal = false }) => {
const [form] = Form.useForm();
const [vidPayments, setVidPayments] = useState([]);
const [users, setUsers] = useState([]);
const [loading, setLoading] = useState(false);
const [item, setItem] = useState(paymentItem);

  const onSave = () => {
    setLoading(true);
    if (!item.id) {
      serverFetch("sale/pay", {method: "POST", bodyData: {...item, docDate: strDate2Server(item.docDate)}})
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
    else {
      serverFetch("payment", {method: "PUT", bodyData: {...item, docDate: strDate2Server(item.docDate)}})
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
     onClose(false);
  }

  const onDelete = () => {
  };

  const onCancel = () => { onClose() };

  const allDisabled = !isAbon;
  useEffect(() => {
    form.setFieldsValue({ ...paymentItem, paymentVidId: paymentItem.paymentVidId ?? null });
    setItem(paymentItem);
    console.log(paymentItem)
    dictsGetPaymentVids((vids) => { // Для автовыбора кассы
      setVidPayments(vids);
      if (!paymentItem.paymentVidId && vids.length > 0) {
        const firstId = vids[0].value;
        setItem(prev => ({ ...prev, paymentVidId: firstId }));
        form.setFieldsValue({ paymentVidId: firstId });
      }
    });
  }, [paymentItem]);

  const onValuesChange = value => setItem({...item, ...value});

  const content = !isMobile ? [
    <Form form={form} className="subtable-item" colon={false} labelCol={{ span: 5 }} wrapperCol={{ span: 20 }} loading={loading} onValuesChange={onValuesChange}>
      <Form.Item label="Сумма" name="syma"><Input disabled={allDisabled || item.id}/></Form.Item>
      <Form.Item label="Дата" name="docDate"><DatePicker format="DD.MM.YYYY" disabled/></Form.Item>
      <Form.Item label="Касса" name="paymentVidId"><Select options={vidPayments} disabled={item.id}/></Form.Item>
      <Form.Item label="Комментарий" name="comment"><Input /></Form.Item>
      {/* <Form.Item label="Сотрудник" name="userId"><Select options={users} disabled/></Form.Item> */}
      <Form.Item label=" ">
        <Space>
          <Popconfirm title="Подтверждение" description="Удалить оплату?" onConfirm={onDelete}>
            <Button disabled={allDisabled || item.id}>Удалить</Button>
          </Popconfirm>
          <Button onClick={onSave}>Сохранить</Button>
          <Button onClick={onCancel}>Отмена</Button>
        </Space>
      </Form.Item>
    </Form>
  ] : [
    <Form form={form} disabled={loading} onValuesChange={onValuesChange} colon={false} labelCol={{ flex: "70px" }} wrapperCol={{ flex: "1" }} className="client-subitem-content">
      <div className="client-flexible-container-for-forms">
      <Form.Item label="Сумма" name="syma" className="client-abon-form-item">
        <Input style={{ width: "90%" }} disabled={allDisabled || item.id}/>
      </Form.Item>
      <Form.Item labelCol={{ flex: "50px" }} className="client-abon-form-item" label="Дата" name="docDate">
        <DatePicker format="DD.MM.YYYY" placeholder="" disabled className="client-abon-form-item"/>
      </Form.Item>
      </div>
      <Form.Item label="Касса" name="paymentVidId">
        <Select options={vidPayments} disabled={item.id} className="client-abon-form-item"/>
      </Form.Item>
      <Form.Item label="Коммент." name="comment">
        <Input className="client-abon-form-item"/>
      </Form.Item>
      <Form.Item label="Сотруд." name="userId">
        <Select options={users} disabled className="client-abon-form-item"/>
      </Form.Item>
      <div className="client-item-line-triple-halfed">
        <Popconfirm title="Подтверждение" description="Удалить оплату?" onConfirm={onDelete}
          placement="top" getPopupContainer={(trigger) => trigger.closest('.client-item-line-double-halfed')} overlayClassName="centered-popconfirm">
          <Button disabled={allDisabled || item.id}>Удалить</Button>
        </Popconfirm>
        <Button onClick={onSave}>Сохранить</Button>
        <Button onClick={onCancel}>Отмена</Button>
      </div>
    </Form>
  ]

  return !isModal ? (
    <>{content}</>) : 
    (<div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose()}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>{isAbon ? "Изменение платежа" : "Возврат платежа"}</span>
            <CloseOutlined className="sport-section-title-close client-close-outlined-button-style" onClick={() => onClose()}/>
          </div>
          <Form form={form} disabled={loading} onValuesChange={onValuesChange} labelCol={{ xs: 6}} wrapperCol={{ xs: 18}} colon={false} layout="inline">
            <Form.Item className="records-form-item-mobile" label="Сумма">
              <Row align="middle" className="records-row-mobile">
                <Col>
                  <Form.Item name="syma" className="record-form-item-with-margin-top-mobile">
                    <Input disabled={allDisabled || item.id} className="records-small-input-mobile"/>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item label="Дата" name="docDate" labelCol={{ span: 2}} className="record-form-item-with-margin-top-mobile">
                    <DatePicker format="DD.MM.YYYY" placeholder="" disabled className="record-date-picker-mobile"/>
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item label="Касса" name="paymentVidId" className="record-form-item-with-margin-top-mobile">
              <Select options={vidPayments} disabled={item.id} className="records-form-item-mobile"/>
            </Form.Item>
            <Form.Item label="Коммент." name="comment" className="record-form-item-with-margin-top-mobile">
              <Input className="records-form-item-mobile"/>
            </Form.Item>
            <Form.Item label="Сотрудник" name="userId" className="record-form-item-with-margin-top-mobile">
              <Select options={users} disabled className="records-form-item-mobile"/>
            </Form.Item>
            <div className="sales-buttons-line-double-halfed" style={{marginTop: "4px"}}>
              <Popconfirm title="Подтверждение" description="Удалить оплату?" onConfirm={onDelete}
                placement="top" getPopupContainer={(trigger) => trigger.closest('.client-item-line-double-halfed')} overlayClassName="centered-popconfirm">
                <Button style={{marginRight: "4px"}} disabled={allDisabled || item.id}>Удалить</Button>
              </Popconfirm>
              <Button onClick={onSave}>Сохранить</Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
    )
};
export default ClientPaymentChange;
